import { useEffect, useState } from "react";
import { RoomCollection } from "@lifeat/shared/data-models/Rooms/RoomEntity";
import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { allRoomIdsOwnedByUser } from "@lifeat/shared/rooms/RoomUtil";
import { useDatabaseContext } from "@contexts/DatabaseContext";
import { RoomMetadata } from "../RoomTypes";

export function useAllRoomMetadataOwnedByUser(userData: UserEntity): RoomMetadata[] {
    const db = useDatabaseContext();
    const roomIds = allRoomIdsOwnedByUser(userData);
    const [metadataList, setMetadataList] = useState<RoomMetadata[]>(roomIds.map((id) => ({ id, name: "Unknown" })));

    useEffect(() => {
        const unsubscribes = roomIds.map((roomId) =>
            db.subscribe(RoomCollection.at(roomId).at("roomName").node, "value", (payload) => {
                if (payload.success) {
                    setMetadataList((original) =>
                        original.map((roomMetadata) =>
                            roomMetadata.id === roomId ? { id: roomId, name: payload.value } : roomMetadata,
                        ),
                    );
                }
            }),
        );

        return () => {
            for (const unsubscribe of unsubscribes) {
                unsubscribe();
            }
        };
    }, [
        JSON.stringify(roomIds), // Depends on roomIds value.
    ]);

    return metadataList;
}
